import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { InfoComponent } from 'components/InfoComponent';
import { Button } from 'components/Button';
import { Url } from 'utils/urls';

const InfoAboutAlternativeLogin = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <InfoComponent
      iconBoxSxProps={{
        alignSelf: 'flex-start',
        paddingTop: '28px'
      }}
    >
      {t('WELCOME_LOGIN_KISA')}
      <br />
      <Button
        onClick={() => navigate(`${Url.chooseLogin}`)}
        variant="outlined"
        color="inherit"
        sx={{
          py: 1,
          textAlign: 'left',
          fontWeight: 700,
          marginTop: 2,
          marginBottom: 0.5
        }}
      >
        {t('WELCOME_LOGIN_KISA_BUTTON')}
      </Button>
    </InfoComponent>
  );
};

export default InfoAboutAlternativeLogin;
